import { isNo, isYes } from '@/features/ApplicationForm/FormConfig/helpers';
import { gender, races } from '../CRForm/ApplicationInformation/constants';

interface IPieChart {
  label: string[];
  dataSets: { data: number; color: string }[];
}

export const useApplicationsGeoLocation = (data: any) => {
  const applicationsList = data?.data;

  const widgetsData: {
    totalApplications: number;
    totalHousePrice: number;
    statusSummary: { [key: string]: number };
    gender: IPieChart;
    totalReceivedAssistance: number;
    maritalStatus: IPieChart;
    totalRaces: IPieChart;
    totalDisabled: IPieChart;
    totalFemaleHeadOfHouseHold: IPieChart;
    totalIncomeBreakDown: IPieChart;
    totalHouseBuiltBefore1978: IPieChart;
    applicationLocationList: Array<{
      id: string;
      [key: string]: string;
      fullAddress: string;
    }>;
  } = {
    totalApplications: 0,
    totalHousePrice: 0,
    statusSummary: {},
    totalRaces: {
      label: races,
      dataSets: [
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#0FCA98' },
        { data: 0, color: '#2B6CB0' },
        { data: 0, color: '#F27141' },
      ],
    },
    totalDisabled: {
      label: ['Yes', 'No'],
      dataSets: [
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#0FCA98' },
      ],
    },
    totalFemaleHeadOfHouseHold: {
      label: ['Yes', 'No'],
      dataSets: [
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#0FCA98' },
      ],
    },
    totalIncomeBreakDown: {
      label: gender,
      dataSets: [
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#0FCA98' },
      ],
    },
    totalHouseBuiltBefore1978: {
      label: ['Yes', 'No'],
      dataSets: [
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#0FCA98' },
      ],
    },
    gender: {
      label: ['Female', 'Male'],
      dataSets: [
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#0FCA98' },
      ],
    },
    totalReceivedAssistance: 0,
    maritalStatus: {
      label: ['Married', 'Unmarried', 'Widowed'],
      dataSets: [
        { data: 0, color: '#0FCA98' },
        { data: 0, color: '#D9B64E' },
        { data: 0, color: '#2B6CB0' },
      ],
    },
    applicationLocationList: [],
  };

  applicationsList?.forEach((a: any) => {
    const { applicationData, id, contactEmail, contactName } = a;

    // Location
    const applicationLocation = `${applicationData?.application?.streetAddress}, ${applicationData?.application?.city}, ${applicationData?.application?.state}, ${applicationData?.application?.zipCode}`;
    widgetsData.applicationLocationList.push({
      id: id,
      email: contactEmail,
      name: contactName,
      phone: applicationData?.application?.phone,
      fullAddress: applicationLocation || '',
    });

    //Total Application Widget
    widgetsData.totalApplications += 1;

    // Total Amount Requested
    widgetsData.totalHousePrice += applicationData?.propertyInformation?.housePrice ? applicationData?.propertyInformation?.housePrice : 0;

    //Status Summary
    widgetsData.statusSummary[a.status] = (widgetsData.statusSummary[a.status] ?? 0) + 1;

    // Total Races
    applicationData?.application?.race?.forEach((r: any) => {
      if (r === 'African-American') widgetsData.totalRaces.dataSets[0].data += 1;
      if (r === 'Caucasian') widgetsData.totalRaces.dataSets[1].data += 1;
      if (r === 'Hispanic') widgetsData.totalRaces.dataSets[2].data += 1;
      if (r === 'Other') widgetsData.totalRaces.dataSets[3].data += 1;
    });

    // Total Disabled
    if (isYes(applicationData?.application?.disabled)) {
      widgetsData.totalDisabled.dataSets[0].data += 1;
    }
    if (isNo(applicationData?.application?.disabled)) {
      widgetsData.totalDisabled.dataSets[1].data += 1;
    }

    // Total Female Head of Household
    if (isYes(applicationData?.application?.femaleHeadOfHousehold)) {
      widgetsData.totalFemaleHeadOfHouseHold.dataSets[0].data += 1;
    }
    if (isNo(applicationData?.application?.femaleHeadOfHousehold)) {
      widgetsData.totalFemaleHeadOfHouseHold.dataSets[1].data += 1;
    }

    // Total House Built Before 1978
    if (isYes(applicationData?.application?.wasBuiltBefore1978)) {
      widgetsData.totalHouseBuiltBefore1978.dataSets[0].data += 1;
    }
    if (isNo(applicationData?.application?.wasBuiltBefore1978)) {
      widgetsData.totalHouseBuiltBefore1978.dataSets[1].data += 1;
    }

    // gender
    if (applicationData?.application?.gender === 'Female') {
      widgetsData.gender.dataSets[0].data += 1;
    }
    if (applicationData?.application?.gender === 'Male') {
      widgetsData.gender.dataSets[1].data += 1;
    }

    // marital status
    if (applicationData?.application?.maritalStatus === 'Married') {
      widgetsData.maritalStatus.dataSets[0].data += 1;
    }
    if (applicationData?.application?.maritalStatus === 'Un-Married') {
      widgetsData.maritalStatus.dataSets[1].data += 1;
    }
    if (applicationData?.application?.maritalStatus === 'Widow') {
      widgetsData.maritalStatus.dataSets[2].data += 1;
    }
  });

  return { widgetsData };
};
